import * as React from 'react';
import SpeedDial from '@mui/material/SpeedDial';
import Tooltip from '@mui/material/Tooltip';
import CategoryIcon from '@mui/icons-material/Category';

import EditIcon from '@mui/icons-material/Edit';


export default function OpenIconSpeedDial({handleClick}) {
  return (
    <Tooltip title="Select Category" placement="right-start">
      <SpeedDial
        ariaLabel="Select Category"
        sx={{ position: 'fixed', bottom: 16, left: 25 }}
        icon={<CategoryIcon />}
        onClick={handleClick}
      />
   </Tooltip>


  );
}
